/* eslint-disable operator-linebreak */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable comma-dangle */
/* eslint-disable object-curly-newline */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useHistory, useParams, useLocation } from 'react-router-dom';
import {
  FormGroup,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
  Button,
  Paper,
  Container,
} from '@mui/material';
import api from '../../services/api';
// import { ReactComponent as LogoGreenfy } from 'images/newLogo/Greenfy-logo-color.svg';
import logoBludocc2 from '../../images/bludocc-logo2.png';
import { useFormik } from 'formik';
import { login } from '../../services/auth';
import * as Yup from 'yup';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useDispatch } from 'react-redux';
import { setNameProperty } from '../../redux/nameProperty';
import { setNameUser } from '../../redux/nameUser';
import { setAuthentication } from '../../redux/authenticated';
import { setDisable } from '../../redux/disable';
import Progress from '../../components/Progress';
import { setSelectedCycle } from 'redux/selectedCycle';
import { useStyles } from '../../components/Styles';
import ReCAPTCHA from 'react-google-recaptcha';
import './styles.css';
import DialogForgotPass from './dialogForgotPass';
import { setUserPermissions } from '../../redux/userPermissions';
import PlatformLogo from 'components/PlatformLogo';
import { BackgroundImageWrapper } from './styles';
import UserService from 'services/UserService';
import { setNotIsFirstAccess } from 'redux/notIsFirstAccess';
import { userPermissionsDomainAction } from 'redux/userPermissionsDomain/actions';

export const withRouter = (Component) => {
  function Wrapper(props) {
    const history = useHistory();
    return <Component history={history} {...props} />;
  }
  return Wrapper;
};

function SignIn() {
  //
  const [showPassword, setShowPassword] = React.useState(false);
  const classes = useStyles();
  const [inProgress, setInProgress] = useState(false);
  const [showSend, setShowSend] = React.useState(true);
  const [showMesage, setShowMesage] = useState(
    localStorage.getItem('concluirCadastro')
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const emailByLocation = location.state?.email;
  const [openDialogForgotPass, setOpenDialogForgotPass] = React.useState(false);

  // const [handleErrors, setHandleErrors] = useState(true);
  const [errors, setErrors] = useState(false);
  const { token } = useParams();
  const ref = useRef(null);
  const [mesageError, setMesageError] = useState(false);

  function onChangeRecaptcha(_value) {
    setShowSend(false);
  }
  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required('Campo Obrigatório'),
      password: Yup.string().required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      dispatch(setDisable(true));
      // dispatch(setLoading(true));
      setInProgress(true);
      request(values);
    },
  });

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // Retorna um valor da tela de registro
  if (localStorage.getItem('concluirCadastro') === 'true') {
    // setTimeout(() => {
    localStorage.setItem('concluirCadastro', false);
    // setShowMesage(false);
    // }, 20000);
  }

  // envia os dados para api salvar no banco
  async function request(data) {
    try {
      const { email, password } = data;
      await login({ email, password });
      localStorage.setItem('email', email);

      const user = await UserService.currentUser();
      dispatch(setNameUser(user.name));
      dispatch(setAuthentication(true));

      dispatch(setUserPermissions(user.permissions));
      dispatch(userPermissionsDomainAction(user.domain_permissions));

      const properties_ = await api.get('/properties/');
      const index = user.last_domain
        ? user.last_domain
        : properties_.data[0].id;
      const property = properties_.data.find((prop) => prop.id === index);

      localStorage.setItem('idProperty', index);
      localStorage.setItem('nameProperty', property.name);
      dispatch(setNameProperty(property.name));

      let path;
      if (properties_?.data[0]?.name !== null) {
        path = '/home';
      } else if (properties_?.data[0]?.name === null) {
        path = '/first-property';
      }

      if (user.firstAccess === false) {
        path = user.permissions.includes('psf_worker')
          ? '/measurements'
          : '/home';
      }

      if (user.permissions[0].includes('user')) {
        if (user.firstAccess) {
          await UserService.updateFirstAccess({ user });
          dispatch(setNotIsFirstAccess(true));
        }
      }

      history.push(path);

      const cycleCodes = await api.get('/cycle-codes');
      dispatch(setSelectedCycle(cycleCodes.data[cycleCodes.data.length - 1]));
    } catch (err) {
      setMesageError(true);
    } finally {
      dispatch(setDisable(false));
      setInProgress(false);
    }
  }

  useEffect(() => {
    dispatch(setDisable(false));
    localStorage.removeItem('persist:root');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const confirmEmail = useCallback(async () => {
    try {
      await UserService.confirmUser({ token });
    } catch (err) {
      setErrors(true);
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      confirmEmail();
    }
  }, [confirmEmail, token]);

  return (
    <BackgroundImageWrapper>
      <Container className="ContainerPrimary">
        <section>
          <Paper className="paper">
            <Typography variant="h6" align="center" gutterBottom>
              <PlatformLogo isLogin srcLogoBludocc={logoBludocc2} />
            </Typography>

            {/* Mensagem de login ou senha inválida */}
            {mesageError ? (
              <section
                style={{
                  backgroundColor: 'rgba(246, 220, 155, 0.33)',
                  padding: '1rem',
                  marginInline: '1rem',
                  borderRadius: '5px',
                }}
              >
                <div
                  style={{
                    color: '#FE5A2C',
                    fontWeight: '700',
                    textAlign: 'center',
                    paddingBottom: '0.5rem',
                  }}
                >
                  Atenção!
                </div>
                <div
                  style={{
                    textAlign: 'center',
                    fontWeight: '700',
                    color: '#000',
                  }}
                >
                  Usuário ou Senha incorreta, verifique novamente se os dados
                  estão corretos.
                </div>
              </section>
            ) : null}

            {/* Mensagem de email confirmado */}
            {token ? (
              <section
                style={{
                  backgroundColor: 'rgba(44, 152, 100, 0.15)',
                  padding: '2rem',
                  marginInline: '1rem',
                  borderRadius: '5px',
                }}
              >
                <div
                  style={{
                    color: '#057C43',
                    fontWeight: '700',
                    textAlign: 'center',
                    paddingBottom: '0.5rem',
                  }}
                >
                  Bem-vindo a Greenfy!
                </div>
                <div style={{ textAlign: 'center' }}>
                  Agora você faz parte da Plataforma Inteligente para Gestão de
                  Fazendas de Camarão e Peixe.
                </div>
                <div
                  style={{
                    textAlign: 'center',
                    fontWeight: '700',
                    fontSize: '15px',
                  }}
                >
                  {errors
                    ? 'Usuário não existe ou o token expirou!'
                    : 'Seu e-mail foi Confirmado com sucesso!'}
                </div>
              </section>
            ) : null}

            {/* Mensagem de confirmação de email */}
            {showMesage === 'true' ? (
              <section
                style={{
                  backgroundColor: 'rgba(44, 152, 100, 0.15)',
                  padding: '2rem',
                  marginInline: '1rem',
                  borderRadius: '5px',
                }}
              >
                <div
                  style={{
                    color: '#057C43',
                    fontWeight: '700',
                    textAlign: 'center',
                    paddingBottom: '0.5rem',
                  }}
                >
                  FALTA POUCO PARA COMEÇAR A ACESSAR A PLATAFORMA!
                </div>
                <div>
                  <p>
                    Precisamos que você confirme o seu cadastro, enviamos um
                    e-mail para:
                    <span style={{ color: '#0076C6', fontWeight: '700' }}>
                      {' '}
                      {emailByLocation}.
                    </span>
                  </p>
                  Por favor, certifique-se de olhar a sua caixa de e-mail ou
                  SPAM.
                </div>
              </section>
            ) : null}

            {inProgress ? <Progress /> : null}
            <form className={classes.root} onSubmit={formik.handleSubmit}>
              <section>
                <h2 className="titleLogin">ACESSO A PLATAFORMA</h2>
              </section>
              <FormGroup>
                <TextField
                  id="formGridName"
                  label="Email"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  name="email"
                  placeholder="Endereço de e-mail"
                  type="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={!!(formik.touched.email && formik.errors.email)}
                  helperText={
                    formik.touched.email &&
                    formik.errors.email &&
                    formik.errors.email
                  }
                />
              </FormGroup>
              <FormGroup>
                <TextField
                  id="formGridResp"
                  label="Senha"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  name="password"
                  placeholder="Senha"
                  type={showPassword ? 'text' : 'password'}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={!!(formik.touched.password && formik.errors.password)}
                  helperText={
                    formik.touched.password &&
                    formik.errors.password &&
                    formik.errors.password
                  }
                />
              </FormGroup>

              <ReCAPTCHA
                className={`${classes.recaptcha} g-recaptcha`}
                sitekey={
                  process.env.REACT_APP_PLATAFORM === 'crevettic'
                    ? '6LeOkXYdAAAAAMXuoD12Qm6yUzZyZwIRewCy_zCT'
                    : '6LcvnXYdAAAAAFd-l9KbUs3YmADoBJs-iBBe_xjZ'
                }
                onChange={onChangeRecaptcha}
                ref={ref}
              />
              <FormGroup>
                <Button
                  style={{ borderRadius: '15px' }}
                  disabled={showSend}
                  className={classes.buttonRegister}
                  variant="contained"
                  type="submit"
                  size="large"
                >
                  Entrar
                </Button>
              </FormGroup>
            </form>

            {openDialogForgotPass && (
              <DialogForgotPass close={() => setOpenDialogForgotPass(false)} />
            )}

            <Typography
              style={{ marginLeft: '1rem' }}
              variant="subtitle1"
              gutterBottom
            >
              Esqueceu a senha?
              <Link
                variant="text"
                onClick={() => setOpenDialogForgotPass(true)}
                style={{
                  color: '#1572c6',
                  textDecoration: 'none',
                }}
              >
                {' '}
                Redefinir minha senha!
              </Link>
            </Typography>
          </Paper>
        </section>
      </Container>
    </BackgroundImageWrapper>
  );
}

export default withRouter(SignIn);
